import type { FC } from "react";
import { Typography } from "@/design-system/Atoms";
import type { TrimixFeaturedMedData } from "@/design-system/Organisms/TrimixFeaturedMedSection/featuredMed.data";
import { BenefitCard } from "@/design-system/Molecules";

interface TrimixFeaturedMedSectionProp {
  heading?: string;
  highlightedHeadingMain?: string;
  highlightedHeadingAccent?: string;
  describe?: string;
  medList: typeof TrimixFeaturedMedData;
}

const TrimixFeaturedMedSection: FC<TrimixFeaturedMedSectionProp> = ({
  heading,
  highlightedHeadingMain,
  highlightedHeadingAccent,
  describe,
  medList,
}) => {
  return (
    <section className="relative block w-full h-full bg-white border-t-[0] rounded-tl-[60px] rounded-tr-[60px] py-[4.68rem] lg:py-[10rem]">      
        <div className="container mx-auto">
          <div className="flex flex-wrap items-end mb-[3.75rem]">
            <div className="max-w-full lg:w-5/12 px-3">
              <Typography variant="categoryText" as="div" className="mb-10">
                {heading}
              </Typography>
              <Typography variant="sectionHeading" as="h2" className="mb-3">
                <>
                  {highlightedHeadingMain}{" "}
                  <span className="text-gray-400">
                    {highlightedHeadingAccent}
                  </span>
                </>
              </Typography>
            </div>
            <div className="max-w-full px-3 lg:ml-[16.666667%] lg:w-5/12">
              <Typography
                variant="sectionDescriptionLarge"
                as="p"
                className="mb-10"
              >
                {describe}
              </Typography>
            </div>
          </div>
          <div className="flex flex-wrap">
            {medList.map((item, index) => (
              <div
                className="w-full px-[1.5rem] mt-[1.5rem] lg:w-1/3"
                key={index}
              >
                <BenefitCard
                  image={item.image}
                  title={item.title}
                  description={item.description}
                  isOralMed = {false} 
                />
              </div>
            ))}
          </div>
        </div>       
    </section>
  );
};
export default TrimixFeaturedMedSection;
